<template>
	<div id="page" v-cloak>
		<mescroll-vue  ref="mescroll" :down="mescrollDown" @init="mescrollInit">
			<div class="income">
				<div class="income_title">
					<p class="advertising_icon">平台收益</p>
					<span class="advertising_describe" @click="Dialog(1)">（每天中午14点自动核算）</span>
				</div>
				<ul class="advertising_details clear">
					<li>
						<p>昨日收益</p>
						<p>{{dividendData.dividends_money}}<span>元</span></p>
					</li>
					<li>
						<p>历史收益</p>
						<p>{{dividendData.sum_dividends_money}}<span>元</span></p>
					</li>
				</ul>
			</div>
			<div class="income">
				<div class="income_title">
					<p class="demon_icon">分红妖</p>
					<span class="advertising_describe" @click="Dialog(2)">（每天中午14点自动核算）</span>
				</div>
				<div class="demon_yesterday">
					<p>昨日收益(元/只)</p>
					<p>{{dividendData.monster_dividends_money}}</p>
				</div>
				<ul class="demon_details clear">
					<li>
						<p>全网总数</p>
						<p>{{dividendData.cur_dividends_monster_count}}</p>
					</li>
					<li>
						<p>今天产出</p>
						<p>{{dividendData.today_dividends_monster_count}}</p>
					</li>
					<li>
						<p>待产出</p>
						<p>{{dividendData.unproduce_dividends_monster_count}}</p>
					</li>
				</ul>
			</div>
			<div class="income my_income">
				<div class="income_title my_income_title">
					<p class="my_income_icon my_earnings">我的收益（每天中午14点自动核算）</p>
				</div>
				<ul class="income_details clear">
					<li>
						<p>累计总收益</p>
						<p>{{dividendData.user_total_income}}<span>元</span></p>
					</li>
					<li>
						<p>昨日收益</p>
						<p>+{{dividendData.yesterday_income}}<span v-if="dividendData.yesterday_income!='未结算'">元</span></p>
					</li>
				</ul>
				<ul class="all_income_details">
					<li class="clear">
						<p class="lt">
							<span class="subheading">我的分红妖</span>
							<span>{{dividendData.user_dividends_monster_count}}只</span>
						</p>
						<p class="rt">
							<span class="subheading"><b>分红妖每日收益</b></span>
							<b>+</b>
							<span class="dividen_dmoney">{{dividendData.monster_dividends_money}}<span v-if="dividendData.monster_dividends_money!='未结算'">元</span></span>
						</p>
					</li>
					<li class="clear">
						<p class="lt">
							<span class="subheading">我的下级</span>
							<span>{{dividendData.friend_count}}人</span>
						</p>
						<p class="rt">
							<span class="subheading"><b>下级抢红包收益</b></span>
							<b>+</b>
							<span class="dividen_dmoney">{{dividendData.friend_dividends_money}}<span v-if="dividendData.friend_dividends_money!='未结算'">元</span></span>
						</p>
					</li>
				</ul>
			</div>
			<div class="btn clear">
				<input class="lt" type="button" value="收益明细" @click="openUrl(1)">
				<input class="rt" type="button" value="邀请好友" @click="openUrl(2)">
			</div>
			<transition name="fade">
				<div class="dialog_masking" v-if="visible" >
					<div class="dialog">
						<p class="dialog_title">提示</p>
						<div class="dialog_content" v-html="dialogContent" v-bind:class="{ dialog_content_center : textAlignCenter}"></div>
						<div class="dialog_button clear" v-if="dialogButton">
							<input type="button" value="取消">
							<input type="button" value="确认">
						</div>
					</div>
				</div>
			</transition>
		</mescroll-vue>
	</div>
</template>

<script>
	import MescrollVue from 'mescroll.js/mescroll.vue'
	export default {
		name: 'ProfitDetails',
		components: {
		  MescrollVue // 注册mescroll组件
		},
		data() {
			return {
				userId: '',
				H5Key: '',
				md5: '',
				dividendData: {},
				mescroll: null, // mescroll实例对象
				mescrollDown:{
					callback: this.downCallback,
				},
				visible: false,
				dialogButton: false,
				textAlignCenter: false,
				dialogContent: "",
				advertisingText: "<p>平台收益是来啊通过各项服务等方式获得的流水收益，全网公开透明，共同监督</p>",
				dividendText: "<p><span style='color: red;font-weight: 600;'>什么是分红妖？</span></br>分红妖是获得来啊平台收益分红的唯一凭证，持有即每天享受平台分红，可提现。</br>分红妖总量有限，固定100000条，直至产完为止，前期参与有更多的优势。当待产出池数量为0，则不再产出分红妖。获得分红妖最大限度公开、透明。</br></br><span style='color: red;font-weight: 600;'>如何获得分红妖？</span></br>1.分红妖可通过两只39级妖合成有概率产出；</br>2.分红妖可通过10只不同的40级妖合成100%产出；</br>备注：分红妖不支持现金充值购买，保证所有用户公平性；</br></br><span style='color: red;font-weight: 600;'>如何分红？</span></br>每天平台会自动核算昨天来啊平台收益和全网分红妖总数，从而计算出每位拥有分红妖的用户当天收益情况，具体分红公式：昨天来啊平台收益*0.2/全网分红妖数量*用户拥有分红妖数量</p>",
			}
		},
		mounted() {
			if(window.LaiaJs){
				window.LaiaJs.setTitle('分红详情');
				this.userId = window.LaiaJs.getUserId();
				this.H5Key = window.LaiaJs.getH5Key();
				this.md5 = this.$md5(this.H5Key);
			}else{
				this.userId = '090405e138b74c9f9ceb397f42633c06';
				this.H5Key = 'PyPtPu4qSx1wTBYEYB4ASyWETrVsSBPv';
				this.md5 = this.$md5(this.H5Key);
			}
		},
		methods: {
			mescrollInit (mescroll) {
			  this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
			},
			downCallback() {
			  //联网请求
			  this.$axios.post("user/getDividendsData.do",  {
			    "user_id": this.userId,
				"sign": this.md5,
			  }).then((res)=> {
			    // console.log(res);
				if(res.data.Error != ""){
					if(window.LaiaJs){
						window.LaiaJs.showMsg(res.data.Error);
						return;
					}else{
						alert(res.data.Error);
						return;
					}
				}
				this.dividendData = res.data;
				this.$nextTick(() => {
				  this.mescroll.endSuccess();
				})
			  }).catch((e)=> {
			    //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
			    this.mescroll.endErr();
			  })
			},
			// 弹窗
			Dialog(code) {
				if(code == 1){
					this.dialogContent = this.advertisingText;
				}else if(code == 2){
					this.dialogContent = this.dividendText;
				}
				this.visible = !this.visible;
				setTimeout(()=>{
					this.visible = !this.visible;
					this.dialogContent = "";
				},2000)
			},
			// 跳转页面
			openUrl(id) {
				if(id == 1){
					if(window.LaiaJs){
						window.LaiaJs.openUrl('http://laia-common.yeedian365.com/laia_h5/index.html#/TradingRecord');
					}else{
						this.$router.push({
						  path: '/TradingRecord',
						}).catch(err => {
						  console.log(err)
						})
					}
				}else if(id == 2){
					if(window.LaiaJs){
						window.LaiaJs.showShareCard();
					}
				}
			},
		}
	}
</script>

<style scoped>
	[v-cloak] {
		display: none;
	}
	#page {
		width: 100%;
		height: 100vh;
		color: #3a4552;
		background-color: #eaf1f7;
	}
	.fade-enter-active, .fade-leave-active {
	  transition: opacity .5s
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
	  opacity: 0
	}
	.income{
		margin: 0.35rem 0.48rem 0 0.48rem;
		border-radius: 0.1rem;
		overflow: hidden;
		background-color: #fff;
	}

	.income_title{
		height: 0.6rem;
		line-height: 0.6rem;
		font-size: 0.4rem;
		font-weight: bold;
		padding: 0.3rem 0.4rem 0 0.4rem;
	}
	.income_title p{
		color: #555;
		padding-left: 0.7rem;
		display: inline-block;
	}
	.income_title .my_earnings{
		color: #fff;
	}
	.my_income_title p{
		padding-left: 0.76rem;
	}
	.income_title .advertising_icon{
		background: url(../img/advertising_icon.png)no-repeat left center;
		background-size: 0.5rem;
	}
	.income_title .demon_icon{
		background: url(../img/demon_icon.png)no-repeat left center;
		background-size: 0.5rem;
	}
	.income_title .my_income_icon{
		background: url(../img/earnings_icon.png)no-repeat left center;
		background-size: 0.63rem 0.4rem;
	}
	.income_title span{
		color: #8a8d97;
	}
	.income_title .advertising_describe{
		padding-right: 0.4rem;
		background: url(../img/describe.png)no-repeat center right;
		background-size: 0.4rem;
	}
	.advertising_details{
		padding: 0.5rem 0.4rem 0.2rem 0.4rem;
	}
	.advertising_details li{
		width: 50%;
		float: left;
	}
	.advertising_details li p:first-child,.demon_details li p:first-child,.demon_yesterday p:first-child,.income_details p:first-child{
		font-size: 0.34rem;
		color: #888f94;
		margin-bottom: 0.2rem;
	}
	.advertising_details li p:last-child,.demon_details li p:last-child,.demon_yesterday p:last-child,.income_details p:last-child{
		font-size: 0.5rem;
		font-weight: bold;
		padding-bottom: 0.2rem;
	}
	.advertising_details li p span,.income_details p span,.dividen_dmoney span{
		font-size: 0.3rem;
	}
	.demon_yesterday{
		padding-top: 0.5rem;
		text-align: center;
		margin-bottom: 0.3rem;
	}
	.demon_yesterday p:last-child{
		text-align: center;
	}
	.demon_details{
		/* height: 1.46rem; */
		padding-top: 0.3rem;
		background-color: #fff3f3;
	}
	.demon_details li,.income_details li{
		float: left;
		text-align: center;
		width: 2.6rem;
	}
	.demon_details li:nth-child(2){
		padding: 0 1.02rem;
	}
	.demon_details li:last-child,.income_details li:last-child{
		float: right;
	}
	.my_income{
		background-color: #3771fa;
	}
	.income_details{
		color: #fff;
		background-color: #3771fa;
		padding-top: 0.6rem;
	}
	.income_details p:first-child{
		color: #fff;
	}
	.all_income_details{

	}
	.all_income_details li{
		font-size: 0.4rem;
		color: #fff;
		padding: 0 0.4rem;
		line-height: 1.2rem;
		background: rgba(255,255,255,0.4);
		margin-bottom: 0.04rem;
	}
	.all_income_details li:last-child{
		margin-bottom: 0;
	}
	.all_income_details .subheading{
		margin-right: 0.2rem;
	}
	.all_income_details li p span{
		display: inline-block;
	}
	.dividen_dmoney{
		font-size: 0.5rem;
		font-weight: bold;
	}
	.btn{
		position: fixed;
		width: 100%;
		bottom: 0;
	}
	.btn input{
		width: 50%;
		height: 1.4rem;
		font-size: 0.4rem;
		color: #fff;
	}
	.btn input:first-child{
		background-color: #3672F9;
	}
	.btn input:last-child{
		background-color: #ffa81d;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ProfitDetails.vue